import React from 'react';
import { Box, Container, Typography } from '@mui/material';

import { Button, Link } from 'gatsby-theme-material-ui';
import SvgImsKit from './SvgImsKit';

export default function SummerSpringBanner({
  banner,
  isMobile,
  setIsModalOpen,
  handleClick,
}) {
  let buttonHandle = null;
  if (banner.buttonAction === 'modal') {
    buttonHandle = () => setIsModalOpen && setIsModalOpen(true);
  }
  if (banner.buttonAction === 'link') {
    buttonHandle = handleClick;
  }
  const button = (
    <Button
      size={isMobile ? 'smallest' : 'medium'}
      variant="kitPrimary"
      onClick={buttonHandle}
      sx={{
        height: { sm: 38, lg: 'fit-content' },
        minWidth: 91,
        position: 'relative',
        zIndex: 999,
      }}
    >
      {banner.buttonText?.split(' ').join(' ')}
    </Button>
  );
  return (
    <Box
      sx={{
        height: { xs: 40, sm: 48, md: 80, lg: 100 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            background:
              'linear-gradient(90.42deg, #E9E9FF 6.56%, #E9EAFD 39.16%, #EDFFC6 93.35%)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <SvgImsKit isMobile={isMobile} />
        </Box>
      </Box>
      <Container
        maxWidth={'xl'}
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          px: { xs: 'calc(48vw - 165px)', sm: 8, md: 12, lg: 10 },
          gap: { xs: 'calc(30vw - 100px)', sm: 1, md: 4, lg: 16, xl: 2 },
          alignItems: 'center',
          justifyContent: { xs: 'flex-start' },
        }}
      >
        <Box
          sx={{
            minWidth: 157,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="desktopH4"
            sx={{
              color: 'kit.infographic.darkPurple',
              fontSize: { xs: 12, sm: 14, md: 18, lg: 20 },
              fontWeight: 400,
              minWidth: { xs: 10, md: 161 },
              maxWidth: { xs: 188, sm: 230, md: 456, lg: 686 },
              letterSpacing: { xs: -0.2, md: 2.25 },
            }}
          >
            {isMobile
              ? banner.bannerMobileText.split('\\n')[0]
              : banner.bannerDesktopText.split('\\n')[0]}
          </Typography>

          <Typography
            variant="desktopH4"
            sx={{
              color: 'kit.infographic.darkPurple',
              fontSize: { xs: 12, sm: 14, md: 18, lg: 20 },
              fontWeight: 400,
              minWidth: { xs: 10, md: 161 },
              maxWidth: { xs: 188, sm: 230, md: 456, lg: 686 },
              letterSpacing: { xs: -0.2, md: 2.25 },
            }}
          >
            {isMobile
              ? banner.bannerMobileText.split('\\n')[1]
              : banner.bannerDesktopText.split('\\n')[1]}
          </Typography>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            right: '50%',
            transform: {
              xs: 'translate(calc(38vw), -50%)',
              lg: 'translate(calc(23vw - 35%), -50%)',
            },
          }}
        >
          {banner.buttonAction === 'link' && (
            <Link
              href={banner.buttonLink}
              target="_blank"
              underline="none"
              children={button}
            />
          )}
          {banner.buttonAction === 'modal' && button}
        </Box>
      </Container>
    </Box>
  );
}
